<template>
    <nav class="m-c-pagination" aria-label="Paginierung">
        <!--
            update translation for aria-labels if we have additional languages
            e.g. Pagination, previous/ next page
            current page: add aria-current="page"
            no previous/ next pages: add aria-disabled="true"
        -->
        <ul class="m-c-pagination__list">
            <!-- show previous page -->
            <li
                @click.prevent="prevPage()"
                class="m-c-pagination__item m-c-pagination__item--prev"
            >
                <!-- disabled if no more previous pages -->
                <!-- uses exi project icon classes (no prefix 'm-')! -->
                <a
                    @click.prevent=""
                    href="#"
                    class="m-c-pagination__link u-icon"
                    :aria-disabled="current === 1 ? `true` : false"
                >
                    <span class="m-u-accessibility">{{
                        $t.message("previousPage")
                    }}</span>
                    <i
                        class="o-icon-font o-icon-font--arrow-left"
                        aria-hidden="true"
                    ></i>
                </a>
            </li>
            <!-- pages -->
            <li
                v-for="n in pages"
                :key="n"
                @click.prevent="updatePage(n)"
                class="m-c-pagination__item"
            >
                <a
                    @click.prevent=""
                    href="#"
                    class="m-c-pagination__link"
                    :aria-current="current === n ? `page` : false"
                >
                    <span class="m-u-accessibility">{{
                        $t.message("previousPage")
                    }}</span>
                    {{ n }}
                </a>
            </li>
            <!-- show next page -->
            <li
                @click.prevent="nextPage()"
                class="m-c-pagination__item m-c-pagination__item--next"
            >
                <!-- uses exi project icon classes (no prefix 'm-')! -->
                <a
                    @click.prevent=""
                    href="#"
                    class="m-c-pagination__link u-icon"
                    :aria-disabled="current === pages ? `true` : false"
                >
                    <span class="m-u-accessibility">{{
                        $t.message("nextPage")
                    }}</span>
                    <i
                        class="o-icon-font o-icon-font--arrow-right"
                        aria-hidden="true"
                    ></i>
                </a>
            </li>
        </ul>
    </nav>
</template>

<script>
export default {
    name: "ListPagination",
    computed: {
        // pages (reactive) depending on current page
        current() {
            return this.$store.getters.currentPage;
        },
        pages() {
            return this.$store.getters.pages;
        },
    },
    methods: {
        // pagination - update page
        updatePage(page) {
            // this.$store.commit("updatePage", page);
            this.$store.dispatch("updatePage", page);
        },
        // pagination - update (prev page)
        prevPage() {
            this.$store.dispatch("prevPage");
        },
        // pagination - update (next page)
        nextPage() {
            this.$store.dispatch("nextPage");
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
